export default __webpack_public_path__ + "static/media/webdev.e72a3d1d.svg";